import { render, staticRenderFns } from "./SubscriptionsHistory.vue?vue&type=template&id=0dd44456&scoped=true"
import script from "./SubscriptionsHistory.vue?vue&type=script&lang=js"
export * from "./SubscriptionsHistory.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionsHistory.vue?vue&type=style&index=0&id=0dd44456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd44456",
  null
  
)

export default component.exports